var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAuthenticatorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6086_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7999 20.175C44.7999 22.2875 43.1103 24 41.026 24H27.9999L22.3999 12.5238L28.4443 1.91309C29.4864 0.0837228 31.7944 -0.543109 33.5994 0.512993L33.6001 0.513412C35.4052 1.56958 36.0238 3.90893 34.9817 5.73846L28.9373 16.35H41.026C43.1103 16.35 44.7999 18.0625 44.7999 20.175Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3539 39.4803L33.3532 39.4807C31.5879 40.5498 29.3307 39.9153 28.3115 38.0635L22.4001 27.3229L16.4887 38.0635C15.4695 39.9153 13.2123 40.5498 11.447 39.4807L11.4463 39.4803C9.68092 38.4112 9.07597 36.0432 10.0951 34.1913L16.0065 23.4498L22.4001 23.2L28.7937 23.4498L34.705 34.1913C35.7242 36.0432 35.1193 38.4112 33.3539 39.4803Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4001 12.2228L20.7332 16.8L16.0065 15.9571L10.0951 5.60054C9.07597 3.81499 9.68091 1.53186 11.4463 0.501073L11.447 0.500662C13.2123 -0.530056 15.4695 0.0817121 16.4887 1.86712L22.4001 12.2228Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 16L17.1818 24H3.80454C1.70335 24 0 22.2091 0 20C0 17.7909 1.70335 16 3.80454 16H21.6Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 24H16L22.4 12.8L28.8 24Z",
    fill: "#185DB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6086_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.8,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuthenticatorLogo);
export default __webpack_public_path__ + "static/media/google-authenticator-logo.6ebcdc193844d6b87d19ef4af88ceb94.svg";
export { ForwardRef as ReactComponent };